module.exports = {
      id: "mobile-share-usage",
      viewBox: "0 0 16.211 17.807",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#mobile-share",
      toString: function () {
        return this.url;
      }
    }